import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import Searcher from './Searcher';
export default Class(Searcher,
/**  @lends EsSearcher# */
{
  fields: null,
  searchindexServiceUrl: null,
  index: null,
  filterTerm: null,
  singular: "",
  plural: "",
  idField: null,
  initialize: function initialize(options) {
    if (typeof options === 'undefined') throw "EsSearcher.initialize: No options";
    if (!options.source) throw "EsSearcher.initialize: No source";
    this.source = options.source;
    options.usesGeoFunctions = true;
    this.Searcher(options);
    this.type = options.singular;
    if (options.type) this.type = options.type;
    this.singular = options.singular;
    this.plural = options.plural;
    this.registerType(this.source, {
      id: this.type,
      singular: this.singular,
      plural: this.plural
    });
    this.fields = options.fields;
    this.searchindexServiceUrl = options.searchindexServiceUrl;
    this.index = options.index;
    if (options.filterTerm) this.filterTerm = options.filterTerm;
    if (options.idField) this.idField = options.idField;
  },
  getDefaultSort: function getDefaultSort() {
    //Override this method for a correct default sort.
    //Return a valid ES sort object (https://www.elastic.co/guide/en/elasticsearch/guide/current/_sorting.html)
    //Default behaviour: Search on first field. May very well not work as ES can't sort analyzed fields (https://www.elastic.co/guide/en/elasticsearch/guide/current/multi-fields.html)
    var defaulSort = {};
    defaulSort[this.fields[0]] = {
      "order": "asc"
    };
    return defaulSort;
  },
  createQueryString: function createQueryString(query) {
    //http://www.elasticsearch.org/guide/en/elasticsearch/guide/current/multi-field-search.html
    var data = {
      fields: this.fields,
      size: query.limit + 3
    };
    var queryString = query.queryString;

    if (queryString === "") {
      data.query = {
        "match_all": {}
      };
      data.sort = this.getDefaultSort();
    } else {
      data.query = this.createQuery(queryString);
    } //if (queryString)
    //http://www.elasticsearch.org/guide/en/elasticsearch/reference/current/search-request-sort.html


    if (this.filterTerm) if (JSON.stringify(this.filterTerm).indexOf("[") > 0) {
      data.filter = {
        query: {
          terms: this.filterTerm
        }
      };
    } else {
      data.filter = {
        query: {
          term: this.filterTerm
        }
      };
    }
    return JSON.stringify(data);
  },
  createLocateString: function createLocateString(id) {
    var data = {
      fields: this.fields,
      size: 1
    };
    data.query = {
      query_string: {
        default_field: this.idField,
        "query": this.idField + ":" + id
      }
    };
    return JSON.stringify(data);
  },
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(id) {
      var queryResult, data, thisHit, displayName, description, resultGeometry, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.idField !== null)) {
                _context.next = 20;
                break;
              }

              _context.next = 3;
              return this.ready();

            case 3:
              queryResult = this.createQueryResult();
              _context.next = 6;
              return fetch2(this.searchindexServiceUrl + this.index + '/_search', {
                data: {
                  source: this.createLocateString(id)
                }
              });

            case 6:
              data = _context.sent;

              if (!(data.hits.hits.length === 1)) {
                _context.next = 17;
                break;
              }

              thisHit = data.hits.hits[0];
              displayName = this.getDisplayName(thisHit);
              description = this.getDescription(thisHit);
              resultGeometry = this.getGeometry(thisHit);
              result = queryResult.addResult(this.source, this.type, displayName, description, resultGeometry, thisHit);
              result.id = id;
              return _context.abrupt("return", result);

            case 17:
              throw new Error('Whoops! ' + this.CLASS_NAME + ' could not locate' + this.idField + ":" + id);

            case 18:
              _context.next = 21;
              break;

            case 20:
              throw new Error('Whoops! get(id) is not implemented in ' + this.CLASS_NAME);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query, caller) {
      var queryResult, result, data, _result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(query.type === 'collapse')) {
                _context2.next = 7;
                break;
              }

              queryResult = this.createQueryResult();
              result = queryResult.addNewQuery(this.source, this.type, this.plural, null, '', null, null, null);
              result.image = this.iconURI;
              caller.fetchSuccess(queryResult);
              _context2.next = 19;
              break;

            case 7:
              _context2.prev = 7;
              _context2.next = 10;
              return fetch2(this.searchindexServiceUrl + this.index + '/_search', {
                data: {
                  source: this.createQueryString(query)
                }
              });

            case 10:
              data = _context2.sent;
              data.query = query;
              _result = this.parseResult(data);
              caller.fetchSuccess(_result);
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](7);
              caller.fetchError(_context2.t0);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[7, 16]]);
    }));

    function fetchData(_x2, _x3) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  parseResult: function parseResult(data) {
    try {
      var queryResult = this.createQueryResult();
      var query = data.query;
      var totalCount = data.hits.total;
      var count = data.hits.hits.length;
      var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data.hits.hits.slice(0, hitsShown)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hit = _step.value;
          this.addResultFromHit(query, queryResult, hit);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) queryResult.addNewQuery(this.source, this.type, this.plural + " (" + totalCount + ")", null, query.queryString, null, null);
      return queryResult;
    } catch (e) {
      throw "Error in parseResult: " + e.message;
    }
  },
  addResultFromHit: function addResultFromHit(query, queryResult, hit) {
    var displayName = this.getDisplayName(hit);
    if (query.type === "cut") displayName += " (" + this.singular + ")";
    var description = this.getDescription(hit);
    var resultGeometry = this.getGeometry(hit);

    if (this.idField !== null) {
      var result = queryResult.addResult(this.source, this.type, displayName, description, resultGeometry, null);
      result.id = this.getIdValue(hit);
      result.isComplete = false;
    } else {
      queryResult.addResult(this.source, this.type, displayName, description, resultGeometry, hit);
    }
  },
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(result) {
      var gotten;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!result.isComplete) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", result);

            case 4:
              result.isComplete = true;
              _context3.next = 7;
              return this.get(result.id);

            case 7:
              gotten = _context3.sent;
              result.data = gotten.data;
              return _context3.abrupt("return", result);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function completeResult(_x4) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  getIdValue: function getIdValue(hit) {
    return hit.fields[this.idField][0];
  },
  getDescription: function getDescription() {
    throw "EsSearcher.getDescription MUST be overwritten by implementation";
  },
  getDisplayName: function getDisplayName() {
    throw "EsSearcher.getDisplayName MUST be overwritten by implementation";
  },
  getGeometry: function getGeometry() {
    throw "EsSearcher.getGeometry MUST be overwritten by implementation";
  },
  createQuery: function createQuery() {
    throw "EsSearcher.createQuery MUST be overwritten by implementation";
  },
  CLASS_NAME: 'Septima.Search.EsSearcher'
});